export default __webpack_public_path__ + "static/media/Group.7269ff02.svg";